__turbopack_context__.v({
  "image": "BeR5va_image",
  "inner": "BeR5va_inner",
  "root": "BeR5va_root",
  "rootSize16": "BeR5va_rootSize16",
  "rootSize20": "BeR5va_rootSize20",
});
